export const JOIN_US_SURVEY_LINK = 'https://7o4i8q515q1.typeform.com/to/A6FEHbQj';